// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"2c3277e9","225":"38018245","571":"78df5248"}[chunkId] + ".chunk.css";
};